var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxEyeHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.222 5.636a1 1 0 0 0 0 1.414l1.351 1.352C4.573 9.332 3.716 10.53 3 12c1.95 4 4.95 6 9 6 1 0 1.935-.122 2.806-.366l2.144 2.144a1 1 0 1 0 1.414-1.414L5.636 5.636a1 1 0 0 0-1.414 0Zm2.603 4.017C6.09 10.265 5.483 11.047 5 12c1.353 2.666 3.686 4 7 4 .386 0 .758-.018 1.117-.054l-.95-.95a3 3 0 0 1-3.16-3.16L6.826 9.653Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.999 12.17-3.166-3.165a3 3 0 0 1 3.166 3.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12c-.483.952-1.092 1.734-1.825 2.347l1.251 1.25c1-.929 1.858-2.128 2.574-3.597-1.95-4-4.95-6-9-6-1 0-1.935.122-2.806.365l1.688 1.689C11.242 8.018 11.614 8 12 8c3.314 0 5.647 1.333 7 4Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxEyeHide);
export default __webpack_public_path__ + "static/media/4-icon-24-px-eye-hide.e8764255.svg";
export { ForwardRef as ReactComponent };